// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"61f27ebb","977":"5fb93a3d"}[chunkId] + ".chunk.js";
};